// Additional UI languages (German, Italian) for the in-app translations.
const coreExtra = {
  de: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    search: 'Suchen',
    loading: 'Lädt...',
    error: 'Fehler',
    success: 'Erfolg',

    dashboard: 'Übersicht',
    profile: 'Profil',
    generatePlan: 'Plan erstellen',
    history: 'Verlauf',
    progression: 'Fortschritt',
    timer: 'Timer',
    strava: 'Strava',
    reminders: 'Erinnerungen',
    plans: 'Abos',
    admin: 'Admin',
    assistant: 'KI-Assistent',
    exercises: 'Übungen',
    logout: 'Abmelden',

    welcome: 'Willkommen zurück',
    hello: 'Hallo',
    completeProfile: 'Vervollständige dein Profil',
    completeProfileDesc: 'Fülle deine Daten aus, um personalisierte Trainingspläne zu erhalten.',
    generateNewPlan: 'Neuen Plan erstellen',
    generateNewPlanDesc: 'Erstelle mit KI einen personalisierten Plan auf Basis deines Profils und deiner Ziele.',
    createPlan: 'Plan erstellen',
    totalPlans: 'Pläne insgesamt',
    completedSessions: 'Abgeschlossene Einheiten',
    averageRating: 'Durchschnittsbewertung',
    progressRecords: 'Fortschrittseinträge',
    recentPlans: 'Letzte Pläne',

    personalData: 'Persönliche Daten',
    physicalData: 'Körperdaten',
    trainingPreferences: 'Trainingsvorlieben',
    age: 'Alter',
    weight: 'Gewicht',
    height: 'Größe',
    experienceLevel: 'Erfahrungsniveau',
    beginner: 'Anfänger',
    intermediate: 'Mittel',
    advanced: 'Fortgeschritten',
    weeklyFrequency: 'Einheiten pro Woche',
    goals: 'Ziele',
    injuries: 'Verletzungen',
    restrictions: 'Einschränkungen',
    preferredCardio: 'Bevorzugtes Cardio',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Andere',
    location: 'Ort',
    phone: 'Telefon',
    birthDate: 'Geburtsdatum',
    language: 'Sprache',
    selectLanguage: 'Sprache wählen',
    nationality: 'Staatsangehörigkeit',
    selectNationality: 'Staatsangehörigkeit wählen',

    generatePlanTitle: 'Plan erstellen',
    generatePlanDesc: 'Erstelle mit KI einen personalisierten Trainingsplan',
    yourProfile: 'Dein Profil',
    dataUsedForPersonalization: 'Daten für die Personalisierung',
    configurePlan: 'Plan konfigurieren',
    workoutType: 'Trainingsart',
    trainingLocation: 'Trainingsort',
    duration: 'Plandauer',
    weeks: 'Wochen',
    cardioTypes: 'Cardio-Arten',
    muscleGroups: 'Muskelgruppen',
    selectMuscles: 'Wähle die Muskeln, die du trainieren willst',
    specialFocus: 'Spezieller Fokus',
    includeVideos: 'Demonstrationsvideos einschließen',
    videosDesc: 'Links zu Videos für jede Übung',
    generateBtn: 'Trainingsplan erstellen',
    generating: 'Plan wird mit KI erstellt...',

    cardio: 'Cardio',
    strength: 'Kraft',
    hiit: 'HIIT',
    circuit: 'Zirkel',

    home: 'Zuhause',
    gym: 'Fitnessstudio',
    both: 'Beides',

    fullBody: 'Ganzkörper',
    chest: 'Brust',
    back: 'Rücken',
    shoulders: 'Schultern',
    arms: 'Arme',
    legs: 'Beine',
    core: 'Rumpf',
    upperBody: 'Oberkörper',
    lowerBody: 'Unterkörper',

    exerciseLibrary: 'Übungsbibliothek',
    exerciseLibraryDesc: 'Entdecke Übungen mit Videodemonstrationen',
    filterByMuscle: 'Nach Muskel filtern',
    filterByEquipment: 'Nach Equipment filtern',
    allMuscles: 'Alle Muskeln',
    allEquipment: 'Alles Equipment',
    noExercisesFound: 'Keine Übungen gefunden',
    exercisesFound: 'Übungen gefunden',
    viewExercise: 'Übung ansehen',

    premiumFeature: 'Premium-Funktion',
    paywallMessage: 'Personalisierte Trainingspläne sind nur für Pro- oder Premium-Abonnenten verfügbar.',
    viewPlansAndUpgrade: 'Abos ansehen und upgraden',

    adminPanel: 'Administrationsbereich',
    adminDesc: 'Nutzer und Abos verwalten und die Plattform überwachen',
    statistics: 'Statistiken',
    users: 'Nutzer',
    totalUsers: 'Nutzer insgesamt',
    newThisWeek: 'Neu diese Woche',
    generatedPlans: 'Erstellte Pläne',
    paidUsers: 'Zahlende Nutzer',
    distributionByPlan: 'Verteilung nach Abo',
    free: 'Kostenlos',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'Nutzerliste',
    filterByPlan: 'Nach Abo filtern',
    allPlans: 'Alle Abos',
    editUser: 'Nutzer bearbeiten',
    userRole: 'Rolle',
    user: 'Nutzer',
    administrator: 'Administrator',

    pricing: 'Preise',
    choosePlan: 'Wähle dein Abo',
    monthly: 'Monat',
    subscribe: 'Abonnieren',
    currentPlan: 'Aktuelles Abo',

    login: 'Anmelden',
    register: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Name',
    noAccount: 'Noch kein Konto?',
    hasAccount: 'Schon ein Konto?',
    createAccount: 'Konto erstellen',
    welcomeBack: 'Willkommen zurück',
    continueJourney: 'Setze deine personalisierte KI-Trainingsreise fort.'
  },

  it: {
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    edit: 'Modifica',
    delete: 'Elimina',
    search: 'Cerca',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',

    dashboard: 'Dashboard',
    profile: 'Profilo',
    generatePlan: 'Genera Piano',
    history: 'Cronologia',
    progression: 'Progressione',
    timer: 'Timer',
    strava: 'Strava',
    reminders: 'Promemoria',
    plans: 'Abbonamenti',
    admin: 'Admin',
    assistant: 'Assistente IA',
    exercises: 'Esercizi',
    logout: 'Esci',

    welcome: 'Bentornato',
    hello: 'Ciao',
    completeProfile: 'Completa il tuo profilo',
    completeProfileDesc: 'Inserisci i tuoi dati per ricevere piani di allenamento personalizzati.',
    generateNewPlan: 'Genera Nuovo Piano',
    generateNewPlanDesc: 'Crea con l’IA un piano personalizzato in base al tuo profilo e ai tuoi obiettivi.',
    createPlan: 'Crea Piano',
    totalPlans: 'Piani Totali',
    completedSessions: 'Sessioni Completate',
    averageRating: 'Valutazione Media',
    progressRecords: 'Registri di Progresso',
    recentPlans: 'Piani Recenti',

    personalData: 'Dati Personali',
    physicalData: 'Dati Fisici',
    trainingPreferences: 'Preferenze di Allenamento',
    age: 'Età',
    weight: 'Peso',
    height: 'Altezza',
    experienceLevel: 'Livello di Esperienza',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzato',
    weeklyFrequency: 'Frequenza Settimanale',
    goals: 'Obiettivi',
    injuries: 'Infortuni',
    restrictions: 'Limitazioni',
    preferredCardio: 'Cardio Preferito',
    gender: 'Genere',
    male: 'Maschio',
    female: 'Femmina',
    other: 'Altro',
    location: 'Località',
    phone: 'Telefono',
    birthDate: 'Data di Nascita',
    language: 'Lingua',
    selectLanguage: 'Seleziona la lingua',
    nationality: 'Nazionalità',
    selectNationality: 'Seleziona la nazionalità',

    generatePlanTitle: 'Genera Piano',
    generatePlanDesc: 'Crea un piano di allenamento personalizzato con l’IA',
    yourProfile: 'Il Tuo Profilo',
    dataUsedForPersonalization: 'Dati usati per la personalizzazione',
    configurePlan: 'Configura Piano',
    workoutType: 'Tipo di Allenamento',
    trainingLocation: 'Luogo di Allenamento',
    duration: 'Durata del Piano',
    weeks: 'settimane',
    cardioTypes: 'Tipi di Cardio',
    muscleGroups: 'Gruppi Muscolari',
    selectMuscles: 'Seleziona i muscoli che vuoi allenare',
    specialFocus: 'Focus Speciale',
    includeVideos: 'Includi video dimostrativi',
    videosDesc: 'Link ai video di ogni esercizio',
    generateBtn: 'Genera Piano di Allenamento',
    generating: 'Generazione del piano con IA...',

    cardio: 'Cardio',
    strength: 'Pesi',
    hiit: 'HIIT',
    circuit: 'Circuito',

    home: 'Casa',
    gym: 'Palestra',
    both: 'Entrambi',

    fullBody: 'Corpo Intero',
    chest: 'Petto',
    back: 'Schiena',
    shoulders: 'Spalle',
    arms: 'Braccia',
    legs: 'Gambe',
    core: 'Core',
    upperBody: 'Parte Superiore',
    lowerBody: 'Parte Inferiore',

    exerciseLibrary: 'Libreria di Esercizi',
    exerciseLibraryDesc: 'Esplora esercizi con dimostrazioni video',
    filterByMuscle: 'Filtra per muscolo',
    filterByEquipment: 'Filtra per attrezzatura',
    allMuscles: 'Tutti i muscoli',
    allEquipment: 'Tutta l’attrezzatura',
    noExercisesFound: 'Nessun esercizio trovato',
    exercisesFound: 'esercizi trovati',
    viewExercise: 'Vedi esercizio',

    premiumFeature: 'Funzione Premium',
    paywallMessage: 'La generazione di piani personalizzati è disponibile solo per gli abbonati Pro o Premium.',
    viewPlansAndUpgrade: 'Vedi gli abbonamenti e passa a Pro',

    adminPanel: 'Pannello di Amministrazione',
    adminDesc: 'Gestisci utenti, abbonamenti e monitora la piattaforma',
    statistics: 'Statistiche',
    users: 'Utenti',
    totalUsers: 'Utenti Totali',
    newThisWeek: 'Nuovi questa Settimana',
    generatedPlans: 'Piani Generati',
    paidUsers: 'Utenti Paganti',
    distributionByPlan: 'Distribuzione per Abbonamento',
    free: 'Gratis',
    pro: 'Pro',
    premium: 'Premium',
    userList: 'Elenco Utenti',
    filterByPlan: 'Filtra per abbonamento',
    allPlans: 'Tutti gli abbonamenti',
    editUser: 'Modifica Utente',
    userRole: 'Ruolo',
    user: 'Utente',
    administrator: 'Amministratore',

    pricing: 'Prezzi',
    choosePlan: 'Scegli il tuo abbonamento',
    monthly: 'mese',
    subscribe: 'Abbonati',
    currentPlan: 'Abbonamento Attuale',

    login: 'Accedi',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    name: 'Nome',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
    createAccount: 'Crea account',
    welcomeBack: 'Bentornato',
    continueJourney: 'Continua il tuo percorso di allenamento personalizzato con l’IA.'
  }
};

export default coreExtra;
